import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=f23b88a8&scoped=true&"
import script from "./TaskType.vue?vue&type=script&lang=js&"
export * from "./TaskType.vue?vue&type=script&lang=js&"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=f23b88a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b88a8",
  null
  
)

export default component.exports